/* eslint-disable max-len */
import React from 'react';
import { createPortal } from 'react-dom';
import './managersArchitectsCardTooltip.scss';
const COPY_ICON_PATH = 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1';

const buildTooltip = (details) => (
  `ID: ${details?.emp_id || details?.emp_no || '-'} | Email: ${details?.email_id || '-'}`
);

const copyEmail = (evt, email) => {
  evt.stopPropagation();
  if (!email || email === '-' || !navigator?.clipboard?.writeText) return;
  navigator.clipboard.writeText(email);
};

const getInitials = (name) => {
  const tokens = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!tokens.length) return 'U';
  if (tokens.length === 1) return tokens[0].slice(0, 1).toUpperCase();
  return `${tokens[0].slice(0, 1)}${tokens[1].slice(0, 1)}`.toUpperCase();
};

const handleMouseEnter = (evt, itemId, setTooltipCoords, setActiveId) => {
  const rowElement = evt.currentTarget;
  const rect = rowElement.getBoundingClientRect();

  // Set coordinates right below the row element item, compensating for global window scrolls
  setTooltipCoords({
    top: rect.bottom + window.scrollY + 6, // 6px padding below target line
    left: rect.left + window.scrollX,
  });
  setActiveId(itemId);
};

const handleMouseLeave = (setActiveId) => {
  setActiveId(null);
};

export const renderPersonItem = (person, idx, variant = 'regular', setActiveId, activeId, tooltipCoords, setTooltipCoords) => {
  const itemId = person?.details?.emp_id || person?.details?.emp_no || person?.name || idx;
  const isHovered = activeId === itemId;

  return (
    <div
      key={itemId}
      className="manager-item"
      onMouseEnter={(evt) => handleMouseEnter(evt, itemId, setTooltipCoords, setActiveId)}
      onMouseLeave={() => handleMouseLeave(setActiveId)}
      style={{ position: 'relative' }}
    >
      <span className="status-dot online" />
      <div className="manager-avatar">{getInitials(person?.name)}</div>
      <span
        className={`manager-name ${variant === 'senior' ? 'is-senior' : 'is-regular'}`}
        title={buildTooltip(person?.details)}
      >
        {person?.name || '-'}
      </span>

      {isHovered && createPortal(
        <div
          className="manager-tooltip"
          style={{
            position: 'absolute',
            top: `${tooltipCoords.top}px`,
            left: `${tooltipCoords.left}px`,
            opacity: 1,
            visibility: 'visible',
            pointerEvents: 'auto',
            zIndex: 99999,
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '6px',
            padding: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
            width: 'max-content',
            minWidth: '240px',
            maxWidth: '320px',
          }}
        >
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div className="tooltip-avatar">{getInitials(person?.name)}</div>
            <div className="tooltip-info">
              <div className="tooltip-name">{person?.name || '-'}</div>
              <div className="tooltip-id">{person?.details?.emp_id || person?.details?.emp_no || '-'}</div>
              <div className="tooltip-email">
                {(person?.details?.email_id && person?.details?.email_id !== '-') ? (
                  <button
                    className="copy-email-btn"
                    aria-label="Copy email"
                    onClick={(evt) => copyEmail(evt, person?.details?.email_id)}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d={COPY_ICON_PATH} />
                    </svg>
                  </button>
                ) : null}
                <span className="tooltip-email-text">{person?.details?.email_id || '-'}</span>
              </div>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </div>
  );
};

